import { isValid } from 'date-fns'
import { useSelector } from 'react-redux'
import { isValidDate } from '../Utility'
import Flatpickr from 'react-flatpickr'
import { Italian } from 'flatpickr/dist/l10n/it'
import { english } from 'flatpickr/dist/l10n/default'

/**
 * Campo data customizzabile
 *
 * @see https://www.npmjs.com/package/react-flatpickr
 *
 * @param {string} className Nome della classe aggiuntiva per il campo di input
 * @param {string} formClassName Nome della classe aggiuntiva per il gruppo di form
 * @param {string} label Etichetta per il campo
 * @param {Date} date Valore della data
 * @param {Function} onChange Funzione di callback quando la data cambia
 * @param {Object} error Messaggio di errore da visualizzare se la data non è valida
 */
export const DateField = (props) => {
  /**
   * Renderizza un messaggio di errore se la data fornita non é valida oppure se esiste un errore personalizzato.
   *
   * @param {Date} date - La data da validare.
   * @returns {JSX.Element} - Un elemento JSX contenente il messaggio di errore.
   */
  const renderErrorMessage = (date) => {
    if (date && !isValidDate(new Date(date))) {
      return <div className="text-danger">Inserire data valida</div>
    } else if (props.error && !props.error.isValid) {
      return <div className="text-danger">{props.error?.msg}</div>
    }
    return <></>
  }

  /**
   * Serve per gestire il cambio della lingua
   */
  const lang = useSelector((state) => state.language.language)

  return (
    <>
      <div className={`form-group ${props.formClassName || ''}`}>
        {props.label && <label>{props.label}</label>}
        <div className="input-group">
          <Flatpickr
            className={`form-control form-control-date ${props.className || ''}`}
            placeholder={lang === 'it' ? 'gg/mm/aaaa' : 'dd/mm/yyyy'}
            options={{
              maxDate: '2500-01-01', // data massima inseribile
              allowInput: true, // abilita l'inserimento da tastiera della data
              dateFormat: 'd/m/Y',
              language: lang === 'it' ? Italian : english,
              locale: lang
            }}
            value={props.date !== null && isValid(new Date(props.date)) ? props.date : ''}
            onChange={([date]) =>
              props.onChange(isValidDate(new Date(date)) ? new Date(date) : undefined)
            }
          />
        </div>
        {renderErrorMessage(props.date)}
      </div>
    </>
  )
}
